/**
 * @desc SKU库存列表
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockSku.getSkuPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
